import { useEffect, useState } from 'react';
import { readReleaseFromHash } from '../components/ReleaseChecklist/hash';

// Reactive accessor for the `release` key in the URL hash. Returns the
// current value (`null` when unset) and re-renders the consumer on
// `hashchange` so back/forward nav and external link paste stay in sync.
//
// Only reads — does not write. Pages that mutate the hash (the main
// /release-checklist surface) own that logic themselves; this hook is for
// consumers that just need to know "which release is the URL pointing at?".
export const useReleaseFromHash = (): string | null => {
  const [release, setRelease] = useState<string | null>(() =>
    readReleaseFromHash(),
  );
  useEffect(() => {
    const onHashChange = () => setRelease(readReleaseFromHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return release;
};
